import { GroupBoxWarningNotification, MessageContainer } from './atoms';
import { GhostButton } from '@ardoq/button';
import { CloseIcon } from '@ardoq/icons';
import { ReactNode, DragEvent } from 'react';

type WarningNotificationRuleProps = {
  message: ReactNode;
  removeRule: VoidFunction;
  onDragEnd: VoidFunction;
  onDragOver: (e: DragEvent<HTMLDivElement>) => void;
  dataTestId?: string;
};

export const WarningNotificationRule = ({
  removeRule,
  onDragOver,
  onDragEnd,
  message,
  dataTestId,
}: WarningNotificationRuleProps) => (
  <GroupBoxWarningNotification
    onDragOver={onDragOver}
    onDragEnd={onDragEnd}
    data-testid={dataTestId}
  >
    <MessageContainer>{message}</MessageContainer>
    <GhostButton
      dataTestId="remove-formatting-rule-button"
      onClick={removeRule}
    >
      <CloseIcon />
    </GhostButton>
  </GroupBoxWarningNotification>
);
